import { useEffect, useState } from 'react';
import NewsCardItem from './newsCardItem.jsx';
import { Link } from 'react-router-dom';

const PoliticalNews = ({ categoryMap, categoryData = {} }) => {

 const categories = Object.values(categoryMap);

const initialSections = categories
  .filter(category =>
    Array.isArray(categoryData?.[category.catId])
  )
  .map(category => ({
    catId: category.catId,
    title: category.firstStep,
    link: category.link,
    news: categoryData[category.catId]
  }));

const [sections, setSections] = useState(initialSections);

 useEffect(() => {

  let cancelled = false;

  const loadRemainingCategories = async () => {

    const remainingCategories = categories.filter(
      category =>
        !Array.isArray(categoryData?.[category.catId])
    );

    if (remainingCategories.length === 0) {
      return;
    }

    const results = await Promise.all(

      remainingCategories.map(async (category) => {

        const {
          firstStep,
          catId,
          link
        } = category;

        try {

          const res = await fetch(
            `https://www.teluguone.com/news_api/catNewsPaginate?catId=${catId}&start=0&total=6`
          );

          if (!res.ok) {
            throw new Error(
              `Failed to fetch category ${catId}`
            );
          }

          const data = await res.json();

          const news = Array.isArray(data?.morenews)
            ? data.morenews
            : [];

          return {
            catId,
            title: firstStep,
            link,
            news
          };

        } catch (error) {

          console.error(
            `Error loading category ${catId}:`,
            error
          );

          return {
            catId,
            title: firstStep,
            link,
            news: []
          };

        }

      })
    );

    if (!cancelled) {

      setSections(prev => [
        ...prev,
        ...results
      ]);

    }

  };

  loadRemainingCategories();

  return () => {
    cancelled = true;
  };

}, [categoryMap, categoryData]);

  return (
    <>
      {sections.map((section) => {

      
        if (
          !Array.isArray(section.news) ||
          section.news.length === 0
        ) {
          return null;
        }

        return (

          <div
            className="category-section"
            key={section.catId}
          >

            <h2
              className="category-section-heading notranslate"
              translate="no"
            >
              {section.title}

             <Link to={section.link} >మరిన్ని →</Link>
            </h2>

            <div className="category-news-grid">

              {section.news.map((item, index) => (

                <NewsCardItem
                  pn={true}
                  key={
                    item?.id ||
                    item?.news_id ||
                    index
                  }
                  item={item}
                  index={index}
                />

              ))}

            </div>

          </div>

        );

      })}
    </>
  );
};

export default PoliticalNews;